import React, { useRef, useEffect, useCallback } from 'react';
import tapeDesktop from '../../assets/valentinesDay/tape.svg';
import tapeMobile from '../../assets/valentinesDay/tapeMobile.svg';

const AnimatedTape = () => {
  const desktopRef = useRef(null);
  const mobileRef = useRef(null);
  const pauseTimerRef = useRef(null);

  const pauseAnimation = useCallback(() => {
    desktopRef.current?.classList.add('is-paused');
    mobileRef.current?.classList.add('is-paused');

    if (pauseTimerRef.current) {
      clearTimeout(pauseTimerRef.current);
    }

    pauseTimerRef.current = setTimeout(() => {
      desktopRef.current?.classList.remove('is-paused');
      mobileRef.current?.classList.remove('is-paused');
    }, 400);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', pauseAnimation, { passive: true });
    window.addEventListener('touchstart', pauseAnimation, { passive: true });
    window.addEventListener('touchmove', pauseAnimation, { passive: true });

    return () => {
      window.removeEventListener('scroll', pauseAnimation);
      window.removeEventListener('touchstart', pauseAnimation);
      window.removeEventListener('touchmove', pauseAnimation);
      if (pauseTimerRef.current) {
        clearTimeout(pauseTimerRef.current);
      }
    };
  }, [pauseAnimation]);

  return (
    <>
      <div
        ref={desktopRef}
        className="valentines-tape valentines-tape-desktop"
        aria-hidden="true"
      >
        <div className="valentines-tape-track">
          <img src={tapeDesktop} alt="" className="valentines-tape-img" />
          <img src={tapeDesktop} alt="" className="valentines-tape-img" />
        </div>
      </div>
      <div
        ref={mobileRef}
        className="valentines-tape valentines-tape-mobile"
        aria-hidden="true"
      >
        <div className="valentines-tape-track valentines-tape-track-mobile">
          <img src={tapeMobile} alt="" className="valentines-tape-img" />
          <img src={tapeMobile} alt="" className="valentines-tape-img" />
          <img src={tapeMobile} alt="" className="valentines-tape-img" />
        </div>
      </div>
    </>
  );
};

export default AnimatedTape;
